import cn from 'classnames';
import type { ComponentPropsWithoutRef } from 'react';
import * as st from './styles.module.scss';

export const TextOverflow = ({
  className,
  noWrap = false,
  ...props
}: ComponentPropsWithoutRef<'p'> & {
  noWrap?: boolean;
}) => <p className={cn(st.overflow, noWrap && st.noWrap, className)} {...props} />;
